<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      width="100%"
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title
            >Dados do log - {{ urlAcionada }} em
            {{ controller }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list three-line subheader>
          <v-list-item v-if="registroAntigo.length != 0">
            <v-list-item-content>
              <v-list-item-title>{{ registroUrlAntigo }}</v-list-item-title>
              <v-data-table
                :headers="registroHeaderAntigo"
                :items="registroAntigo"
              >
              </v-data-table>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="registroNovo.length != 0">
            <v-list-item-content>
              <v-list-item-title>{{ registroUrlNovo }}</v-list-item-title>
              <v-data-table :headers="registroHeaderNovo" :items="registroNovo">
              </v-data-table>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
  name: "HistoricoLog",
  props: {
    registroAntigo: Array,
    registroUrlAntigo: String,
    urlAcionada: String,
    controller: String,
    registroHeaderAntigo: Array,
    registroNovo: Array,
    registroUrlNovo: String,
    registroHeaderNovo: Array,
    dialog: Boolean,
  },
  methods: {
    sync() {
      this.$emit("sync-dialog", { dialog: false });
    },
    close() {
      this.sync();
    },
  },
};
</script>
